import styled from 'styled-components'

const DebateStyle = styled.div.attrs({})`
    width:calc(100%  - var(--sp4x));
    margin-right:var(--sp4x);
    margin-top: var(--sp4x);
    align-content: flex-start;
    align-items:stretch;

    .single-debate-window {
        width: calc(50% - var(--sp2x));
        margin-bottom: var(--sp4x);
        /* height: var(--sp48x); */

        &:nth-child(2n){
            margin-left:var(--sp2x);
        }
        
        &:nth-child(2n-1){
            margin-right:var(--sp2x);
        }
    }

    /* @media screen and (max-width:${(props) => props.theme.mediaQuery.LaptopSize}){
        .single-debate-window {
            height: var(--sp56x);
        }
    } */

    @media screen and (max-width:${(props) => props.theme.mediaQuery.TabletSize}){
        flex-direction: column;
        width:calc(100%  - var(--sp3x));
        margin-right:var(--sp3x);
        margin-top: var(--sp3x);

        .single-debate-window {
            width: 100%;
            margin-bottom: var(--sp3x);
            /* height: var(--sp50x); */

            &:nth-child(2n){
                margin-left:0;
            }
            
            &:nth-child(2n-1){
                margin-right:0;
            }
        }
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.TabletSizeS}){
        width:100% ;
        flex-direction: column;
        margin-right:0;
        margin-top: var(--sp3x);

        .single-debate-window {
            width: 100%;
            margin-bottom: var(--sp3x);
            /* height: var(--sp45x); */

            &:nth-child(2n){
                margin-left:0;
            }
            
            &:nth-child(2n-1){
                margin-right:0;
            }
        }
    }
`
export default DebateStyle
